<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epi2"> </p>
<p class="ep"><span class="epub-i">Gulag</span> is a Russian acronym for</p>
<p class="ep">Chief Administration of</p>
<p class="ep">Corrective Labor Camps.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epi2.vue?b9a7adf0